import React from 'react';

/**
 * Component to render Cups cards (Ace - Ten) with multiple cup elements
 * arranged in traditional tarot card layouts
 */
const CupsCardLayout = ({ number }) => {
  const cupImage = '/cards/cups/cup-element.png';
  
  // Define layouts for each number (1-10)
  const layouts = {
    1: { // Ace - Single LARGE cup filling the card
      cups: [{ top: '50%', left: '50%', size: '90%', transform: 'translate(-50%, -50%)' }]
    },
    2: { // Two cups facing each other
      cups: [
        { top: '50%', left: '30%', size: '45%', transform: 'translate(-50%, -50%)' },
        { top: '50%', left: '70%', size: '45%', transform: 'translate(-50%, -50%) scaleX(-1)' }
      ]
    },
    3: { // Three cups in triangle
      cups: [
        { top: '30%', left: '50%', size: '40%', transform: 'translate(-50%, -50%)' },
        { top: '65%', left: '30%', size: '40%', transform: 'translate(-50%, -50%)' },
        { top: '65%', left: '70%', size: '40%', transform: 'translate(-50%, -50%)' }
      ]
    },
    4: { // Four cups in square
      cups: [
        { top: '30%', left: '35%', size: '35%', transform: 'translate(-50%, -50%)' },
        { top: '30%', left: '65%', size: '35%', transform: 'translate(-50%, -50%)' },
        { top: '70%', left: '35%', size: '35%', transform: 'translate(-50%, -50%)' },
        { top: '70%', left: '65%', size: '35%', transform: 'translate(-50%, -50%)' }
      ]
    },
    5: { // Five cups - cross pattern
      cups: [
        { top: '25%', left: '50%', size: '32%', transform: 'translate(-50%, -50%)' },
        { top: '50%', left: '25%', size: '32%', transform: 'translate(-50%, -50%)' },
        { top: '50%', left: '50%', size: '32%', transform: 'translate(-50%, -50%)' },
        { top: '50%', left: '75%', size: '32%', transform: 'translate(-50%, -50%)' },
        { top: '75%', left: '50%', size: '32%', transform: 'translate(-50%, -50%)' }
      ]
    },
    6: { // Six cups - two columns
      cups: [
        { top: '20%', left: '35%', size: '30%', transform: 'translate(-50%, -50%)' },
        { top: '20%', left: '65%', size: '30%', transform: 'translate(-50%, -50%)' },
        { top: '43%', left: '35%', size: '30%', transform: 'translate(-50%, -50%)' },
        { top: '43%', left: '65%', size: '30%', transform: 'translate(-50%, -50%)' },
        { top: '66%', left: '35%', size: '30%', transform: 'translate(-50%, -50%)' },
        { top: '66%', left: '65%', size: '30%', transform: 'translate(-50%, -50%)' }
      ]
    },
    7: { // Seven cups - pyramid with center
      cups: [
        { top: '18%', left: '50%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '38%', left: '30%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '38%', left: '50%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '38%', left: '70%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '62%', left: '35%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '62%', left: '65%', size: '28%', transform: 'translate(-50%, -50%)' },
        { top: '82%', left: '50%', size: '28%', transform: 'translate(-50%, -50%)' }
      ]
    },
    8: { // Eight cups - two columns of four
      cups: [
        { top: '16%', left: '35%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '16%', left: '65%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '38%', left: '35%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '38%', left: '65%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '60%', left: '35%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '60%', left: '65%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '82%', left: '35%', size: '26%', transform: 'translate(-50%, -50%)' },
        { top: '82%', left: '65%', size: '26%', transform: 'translate(-50%, -50%)' }
      ]
    },
    9: { // Nine cups - 3x3 grid
      cups: [
        { top: '18%', left: '25%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '18%', left: '50%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '18%', left: '75%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '43%', left: '25%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '43%', left: '50%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '43%', left: '75%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '68%', left: '25%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '68%', left: '50%', size: '25%', transform: 'translate(-50%, -50%)' },
        { top: '68%', left: '75%', size: '25%', transform: 'translate(-50%, -50%)' }
      ]
    },
    10: { // Ten cups - pyramid of 4-3-2-1
      cups: [
        { top: '15%', left: '20%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '15%', left: '40%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '15%', left: '60%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '15%', left: '80%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '40%', left: '30%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '40%', left: '50%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '40%', left: '70%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '65%', left: '40%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '65%', left: '60%', size: '22%', transform: 'translate(-50%, -50%)' },
        { top: '85%', left: '50%', size: '22%', transform: 'translate(-50%, -50%)' }
      ]
    }
  };

  const layout = layouts[number];
  
  if (!layout) return null;

  return (
    <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: 'none',
      zIndex: 2
    }}>
      {layout.cups.map((cup, index) => (
        <img
          key={index}
          src={cupImage}
          alt="Cup"
          style={{
            position: 'absolute',
            top: cup.top,
            left: cup.left,
            width: cup.size,
            height: 'auto',
            transform: cup.transform,
            filter: 'drop-shadow(0 6px 12px rgba(139, 92, 246, 0.5)) drop-shadow(0 0 20px rgba(59, 130, 246, 0.3))',
            opacity: 0.95
          }}
        />
      ))}
    </div>
  );
};

export default CupsCardLayout;
